
import { Navigate, Route, Routes, useNavigate } from 'react-router-dom';
import './App.css'
import routeCollection from './routes/routes';
import NotFound from './pages/notefound/NotFound';
import { getToken, messaging, onMessage } from "./firebase";
import { notification, List, Avatar } from 'antd';
import { User2 } from 'lucide-react';
import { useEffect } from 'react';
import { useAuth } from './context/authContext';
import Logo from "./assets/png/logo.png"

function App() {
  const { getFcmToken } = useAuth()
  const FcmAccessTokens = import.meta.env.VITE_APP_FCM_TOKENS

  useEffect(() => {
    const requestPermissionAndToken = async () => {
      try {
        const currentPermission = Notification.permission;
        if (currentPermission === "granted") {
          const token = await getToken(messaging, {
            vapidKey: FcmAccessTokens,
          });
          console.log("get fcm token", token)
          if (token) {
            getFcmToken(token);
          }

          return;
        }

        // Permission already denied → don't show custom popup again
        if (currentPermission === "denied") {
          return;
        }

        // Check if our custom popup was already shown
        const notificationPromptShown =
          localStorage.getItem("notificationPromptShown");

        if (notificationPromptShown === "true") {
          return;
        }

        // Mark as shown BEFORE displaying popup
        localStorage.setItem(
          "notificationPromptShown",
          "true"
        );

        const userConfirmed = window.confirm(
          "We'd like to send you notifications. Please allow notifications to stay updated."
        );

        if (!userConfirmed) {
          return;
        }

        const permission =
          await Notification.requestPermission();

        if (permission === "granted") {
          const token = await getToken(messaging, {
            vapidKey: FcmAccessTokens,
          });

          if (token) {
            getFcmToken(token);
          }
        }
      } catch (error) {
        console.error(
          "Error getting FCM token:",
          error
        );
      }
    };

    requestPermissionAndToken();
  }, []);

  useEffect(() => {
    const handleMessage = (payload) => {
      console.log("Message received. ", payload);
      notification.open({
        placement: "topRight",
        style: {
          padding: 0,
        },
        message: (
          <List size="small" itemLayout="horizontal">
            <List.Item>
              <List.Item.Meta
                avatar={<Avatar src={Logo} icon={<User2 />} size={40} />}
                title={<span>{payload?.notification?.title}</span>}
                description={payload?.notification?.body}
              />
            </List.Item>
          </List>
        ),
      });
    };

    const unsubscribe = onMessage(messaging, handleMessage);
    return () => {
      unsubscribe();
    };
  }, []);
  return (
    <>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        {routeCollection.map((route, index) => {
          if (route.children) {
            return (
              <Route
                key={index}
                path={route.path}
                element={route.element}
              >
                {route.children.map((childRoute, childIndex) => (
                  <Route
                    key={childIndex}
                    path={childRoute.path}
                    element={childRoute.element}
                  />
                ))}
              </Route>
            );
          }
          return (
            <Route
              key={index}
              path={route.path}
              element={route.element}
            />
          );
        })}
        <Route path="*" element={<NotFound />} />
      </Routes>
    </>
  )
}

export default App
